<template>
  <!-- 导航栏组件 -->
  <div
    class="bottom-menu"
  >
    <div
      v-for="item in menus"
      :key="item.title"
    >
      <template v-if="item.children">
        <div
          v-if="item.children.length > 0"
          :key="item.title"
          class="menu-item"
        >
          <div>
            <div>{{ item.title }}</div>
            <div
              v-for="child in item.children"
              :key="child.title"
              class="sub-menu"
              @click="handleMenuChange(child)"
            >
              {{ child.title }}
            </div>
          </div>
        </div>
      </template>
      <div
        v-else
        :key="item.title"
        class="menu-item"
        :index="item.title"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useMenu } from '~/composables/useMenu'

const { menus, handleMenuChange } = useMenu()
</script>

<style scoped lang="scss">
.bottom-menu {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 100px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  .menu-item {
    font-size: 20px;
    color: #ffffff;
    .sub-menu {
      font-size: 16px;
      color: #ffffff;
      opacity: 0.7;
      line-height: 20px;
      margin-top: 20px;
      cursor: pointer;
    }
  }
}
</style>
